import { ActionTree, GetterTree, MutationTree } from 'vuex'
import { IEmployeeState } from './model'
import { IRootState } from '@/store/model'

const states: IEmployeeState = {
  id: null,
  fullName: null,
  phoneNumber: null,
  personnelNumber: null,
  birthPlace: null,
  birthDate: null,
  gender: null,
  maritalStatus: null,
  address: null,
  city: null,
  province: null,
  postalCode: null,
  highestEducationLevel: null,
  imageUrl: null,
  joinDate: null,
  documents: [],
  employments: [],
  formStep: 1,
  employeeContract: undefined,
  employeeContractLabel: undefined,
  filters: {
    positions: [] as any,
    regions: [] as any
  }
}

const mutations: MutationTree<IEmployeeState> = {
  SET_EMPLOYEE_CONTRACT: (state, data: any) => {
    state.employeeContract = data
  },
  SET_EMPLOYEE_CONTRACT_LABEL: (state, data: any) => {
    state.employeeContractLabel = data
  },
  SET_EMPLOYEE_DATA: (state, data: IEmployeeState) => {
    state.id = data.id
    state.fullName = data.fullName
    state.phoneNumber = data.phoneNumber
    state.personnelNumber = data.personnelNumber
    state.birthPlace = data.birthPlace
    state.birthDate = data.birthDate
    state.gender = data.gender
    state.maritalStatus = data.maritalStatus
    state.address = data.address
    state.city = data.city
    state.province = data.province
    state.postalCode = data.postalCode
    state.highestEducationLevel = data.highestEducationLevel
    state.imageUrl = data.imageUrl
    state.joinDate = data.joinDate
    state.documents = data.documents
    state.employments = data.employments
  },
  SET_EMPLOYEE_FORM_STEP: (state, data: number) => {
    state.formStep = data
  },
  SET_EMPLOYEE_ID: (state, data: any) => {
    state.id = data
  },
  FLUSH_EMPLOYEE_DATA: (state) => {
    state.id = null
    state.fullName = null
    state.phoneNumber = null
    state.personnelNumber = null
    state.birthPlace = null
    state.birthDate = null
    state.gender = null
    state.maritalStatus = null
    state.address = null
    state.city = null
    state.province = null
    state.postalCode = null
    state.highestEducationLevel = null
    state.imageUrl = null
    state.joinDate = null
    state.documents = []
    state.employments = []
  },
  SET_EMPLOYEE_FILTER: (state, data: any) => {
    state.filters = data
  },
  FLUSH_EMPLOYEE_FILTER: (state) => {
    state.filters = {
      positions: [],
      regions: []
    }
  }
}

const actions: ActionTree<IEmployeeState, IRootState> = {
  setEmployeeContract: async ({ commit }, data) => {
    commit('SET_EMPLOYEE_CONTRACT', data)
  },
  setEmployeeContractLabel: async ({ commit }, data) => {
    commit('SET_EMPLOYEE_CONTRACT_LABEL', data)
  },
  setEmployeeData: async ({ commit }, data) => {
    commit('SET_EMPLOYEE_DATA', data)
  },
  setEmployeeFormStep: async ({ commit }, data) => {
    commit('SET_EMPLOYEE_FORM_STEP', data)
  },
  setEmployeeId: async ({ commit }, data) => {
    commit('SET_EMPLOYEE_ID', data)
  },
  flushEmployeeData: async ({ commit }) => {
    commit('FLUSH_EMPLOYEE_DATA')
  },
  setEmployeeFilter: async ({ commit }, data) => {
    commit('SET_EMPLOYEE_FILTER', data)
  },
  flushEmployeeFilter: async ({ commit }) => {
    commit('FLUSH_EMPLOYEE_FILTER')
  }
}

const getters: GetterTree<IEmployeeState, IRootState> = {
  getEmployeeId(state) {
    return state.id
  },
  getEmployeeData(state) {
    return state
  },
  getEmployeeFormStep(state) {
    return state.formStep
  },
  getEmployeeDocuments(state) {
    return state.documents
  },
  getEmployeeEmployments(state) {
    return state.employments
  },
  getEmployeeContract(state) {
    return state.employeeContract
  },
  getEmployeeContractLabel(state) {
    return state.employeeContractLabel
  },
  getEmployeeFilter(state) {
    return state.filters
  }
}

export default {
  namespaced: true,
  state: states,
  mutations,
  actions,
  getters
}